import React, { FC, PropsWithChildren, ReactNode } from 'react';
import Image from 'next/image';
import SubPageLayout from '@/layouts/SubPage';

interface IErrorLayoutProps extends PropsWithChildren<{}> {
  type?: 500 | 404 | 'offline';
  headerTitle?: string;
  title?: ReactNode;
  description?: ReactNode;
  className?: string;
}

const ErrorLayout: FC<IErrorLayoutProps> = ({
  type,
  headerTitle = '',
  title,
  description,
  children,
  className,
}) => (
  <SubPageLayout
    classNames={{ root: className, container: '!flex-1' }}
    hasCardHeaderBorder={false}
    title={headerTitle}
    showSupportButtonOnDesktop
    showSupportButtonOnMobile
  >
    <div className="flex flex-1 flex-col items-center justify-center">
      <div className="my-auto flex flex-col items-center justify-center gap-y-3">
        {!!type && (
          <div className="mb-6">
            <Image
              alt="خطا"
              height={78}
              src={`https://s3.ir-thr-at1.arvanstorage.com/mofidapp/error/${type}.webp`}
              width={78}
            />
          </div>
        )}
        {!!title && (
          <div className="text-base font-demibold text-blue">{title}</div>
        )}
        {!!description && (
          <div className="text-sm font-regular text-gray-120">
            {description}
          </div>
        )}
      </div>
      {children}
    </div>
  </SubPageLayout>
);

export default ErrorLayout;
